import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@circle-react/contexts";
import { useMobileWebFlags } from "@circle-react/hooks/useMobileWebFlags";
import { Icon } from "@circle-react-shared/Icon";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { Typography } from "@circle-react-uikit/Typography";

export interface ChatExportSpaceOptionsProps {
  onChatExport: () => void;
}

export const ChatExportSpaceOptions = ({
  onChatExport,
}: ChatExportSpaceOptionsProps) => {
  const { isViewOnlyMasquerading } = usePunditUserContext();
  const { isMobileWebNewSpaceCustomizationUIEnabled } = useMobileWebFlags();

  const label = t("space_header.chat_export");

  if (isMobileWebNewSpaceCustomizationUIEnabled) {
    return (
      <button
        type="submit"
        className="flex w-full items-center justify-between px-5 py-2.5"
        onClick={onChatExport}
      >
        <div className="flex items-center gap-4">
          <Icon type="20-download" size={20} className="text-default" />
          <Typography.LabelSm color="text-light" weight="medium">
            {label}
          </Typography.LabelSm>
        </div>
        <Icon type="16-chevron-right" size={16} className="text-default" />
      </button>
    );
  }

  return (
    <Dropdown.IconWithBadgeList
      options={[
        {
          value: label,
          label,
          onClick: isViewOnlyMasquerading ? noop : onChatExport,
          icon: "20-download",
          iconSize: 20,
        },
      ]}
    />
  );
};
